module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_4_1.68fb572b.png";